import React from "react";
import { Input, Button, Popover } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";

import styles from "../../styles/Registers.module.css";

export const Heading = ({ searchValue, onSearch, onCreatePatientClicked }) => {
  return (
    <div className={styles.headingActions}>
      <div className={styles.searchInput}>
        <Input
          placeholder="Pretraži"
          value={searchValue}
          suffix={<SearchOutlined />}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      <div>
        <Popover content="Dodaj pacijenta" trigger="hover">
          <div>
            <Button
              type="primary"
              className={styles.addButton}
              onClick={onCreatePatientClicked}
            >
              <PlusOutlined />
              Dodaj
            </Button>
          </div>
        </Popover>
      </div>
    </div>
  );
};
